<template>
  <a :href="url" class="popupPDF">
    <img v-if="previewUrl" :src="previewUrl" alt="pdf lightbox preview" />
  </a>
</template>

<script>
import { pdfPageToImage } from "@/helpers/pdf";
import { blobToDataUrl } from "@/helpers/files";

export default {
  props: {
    url: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      previewUrl: ""
    }
  },
  async mounted() {
    this.previewUrl = await blobToDataUrl(await pdfPageToImage(this.url, 1));
  }
}
</script>

<style scoped>
  a {
    display: block;
    max-height: 600px;
    overflow: hidden;
    background-color: #f9f9f9;
  }

  img {
    width: 100%;
  }
</style>
